/* Cuando hay una versión nueva de la app, un aviso discreto para cargarla (nunca se recarga sola:
   podría pillar a mitad de apuntar un gasto). */
import { useRegisterSW } from 'virtual:pwa-register/react';

export function Actualizar() {
  const { needRefresh: [hay], updateServiceWorker } = useRegisterSW({
    onRegisteredSW(_url, registro) {
      // Mira si hay versión nueva cada hora mientras la app está abierta
      if (registro) setInterval(() => { void registro.update(); }, 60 * 60 * 1000);
    },
  });
  if (!hay) return null;
  return (
    <button type="button" className="pildora actualizar" onClick={() => updateServiceWorker(true)}>
      <span className="num" aria-hidden="true">新</span>Hay una versión nueva · actualizar
    </button>
  );
}
